import React, { Component } from "react";
import Styles from "./ImageSectionModal.module.css";

const ImageSectionModal = (props) => {

const handleClick = () =>{
  props.setImageSectionModalImage(null)
  
}

  return (
    <div className={Styles["backdrop"]}>
      <p onClick={handleClick}>x</p>
      <img src={props.imageSectionModalImage} />
    </div>
  );
};

export default ImageSectionModal;
